import React, { useState, useEffect, useRef } from 'react';
import { getFirestore, Timestamp, doc, setDoc, collection, query, getDocs, where } from "@firebase/firestore";
import { app } from '../firebase.js';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVideoCamera } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import swal from 'sweetalert';
import Spinner from 'react-bootstrap/Spinner';
import CountryOptions from '../Components/CountryOptions.js';
import CurrencyOptions from '../Components/CurrencyOptions.js';

function BranchesComp() {
  const db = getFirestore(app);
  const auth = getAuth();
  const [teamsList, setTeamsList] = useState([]);
  const [loading, setLoading] = useState(true); // State to manage loading
  const [modalShowUp, setModalShowUp] = useState(false);
  const branchRef = useRef();
  const countryRef = useRef();
  const townRef = useRef();
  const currencyRef = useRef();

  // Fetch all Active Students
  useEffect(() => {
    const fetchTeamsAndUsers = async () => {
      setLoading(true); // Set loading to true when fetching starts
      const user = auth.currentUser;
      if (user) {
        try {
          const branchesQuery = query(collection(db, "Branches"));
          const branchesSnapshot = await getDocs(branchesQuery);

          let teamsItem = [];

          for (let doc of branchesSnapshot.docs) {
            const branchName = doc.data().branchName;
            const usersQuery = query(collection(db, "users"), where("userStatus", "==", "Student"), where("classType", "==", branchName));
            const usersSnapshot = await getDocs(usersQuery);

            let usersItem = [];
            usersSnapshot.forEach((userDoc) => {
              usersItem.push({ id: userDoc.id, ...userDoc.data() });
            });

            teamsItem.push({
              id: doc.id,
              ...doc.data(),
              myquerysize: usersSnapshot.size,
              users: usersItem,
            });
          }

          setTeamsList(teamsItem);
        } catch (error) {
          console.error("Error fetching data: ", error);
        } finally {
          setLoading(false); // Set loading to false after fetching completes
        }
      }
    };

    onAuthStateChanged(auth, (user) => {
      if (user) {
        fetchTeamsAndUsers();
      }
    });
  }, [auth, db]);

  const submitNewBranch = async () => {
    const branch = branchRef.current.value;
    const country = countryRef.current.value;
    const town = townRef.current.value;
    const currency = currencyRef.current.value;

    document.getElementById("submitBtn").style.display = "none";
    document.getElementById("spinnerbtn").style.display = "block";

    try {
      const newDataRef = doc(collection(db, "Branches"));
      await setDoc(newDataRef, {
        branchName: branch,
        Country: country,
        Town: town,
        timeCreated: Timestamp.now(),
        docID: newDataRef.id,
        Currency: currency,
      });

      swal("Success!", "Branch added successfully", "success");
      setTeamsList([...teamsList, {
        id: newDataRef.id,
        branchName: branch,
        Country: country,
        Town: town,
        Currency: currency,
        myquerysize: 0,
        users: [],
      }]); // Update state with new branch
    } catch (error) {
      console.error("Error adding branch: ", error);
      swal("Error!", "Failed to add branch", "error");
    } finally {
      document.getElementById("submitBtn").style.display = "block";
      document.getElementById("spinnerbtn").style.display = "none";
      setModalShowUp(false); // Close modal
    }
  };

  function MyUpdateModal(props) {
    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add a New Branch
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="formBranchName">
            <Form.Label>Branch Name</Form.Label>
            <Form.Control type="text" placeholder="Branch name" ref={branchRef} />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formCountry">
            <Form.Label>Country</Form.Label>
            <Form.Select aria-label="Default select example" ref={countryRef}>
              <CountryOptions />
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3" controlId="formTown">
            <Form.Label>Town</Form.Label>
            <Form.Control type="text" placeholder="Town" ref={townRef} />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formCurrency">
            <Form.Label>Currency</Form.Label>
            <Form.Select aria-label="Default select example" ref={currencyRef}>
              <CurrencyOptions />
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button className='btn btn-dark' onClick={props.onHide}>Close</Button>
          <Button variant="primary" onClick={submitNewBranch} disabled={loading}>
            {loading ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                <span> Sending...</span>
              </>
            ) : (
              'Send'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <div className='teamsComponent'>
      <div className='teamsTopBar'>
        <h5 className='tHide1'>Branches</h5>
        <h5 className='tHide2'>Branches</h5>
        <button className='startOnlSessBtn' onClick={() => setModalShowUp(true)}>
          <FontAwesomeIcon icon={faVideoCamera} className="liveSessionIcon" /> Add a new Branch
        </button>
        <button className='startOnlSessBtn2' onClick={() => setModalShowUp(true)}>
          <FontAwesomeIcon icon={faVideoCamera} className="liveSessionIcon" /> Add a new Branch
        </button>
      </div>
      <br />
      {loading ? (
        <div className="spinner-container">
          <Spinner animation="border" role="status" />
          <span>Loading...</span>
        </div>
      ) : (
        teamsList.map((myteam) => {
          const profileUsers = myteam.users.filter(user => user.profilePic).slice(0, 3);
          const remainingUsersCount = myteam.myquerysize - profileUsers.length;
          return (
            <div className='channelItem' key={myteam.id}>
              <div className='channelItemTop'></div>
              <div className='channelItemCont'>
                <h5>{myteam.branchName}</h5>
                <p>Located in {myteam.Country}, {myteam.Town}</p>
                <div className='profilePlaceHolderCont'>
                  {profileUsers.map((myuser) => (
                    <div className='profileChannel' key={myuser.id}>
                      <img src={myuser.profilePic} alt="" />
                    </div>
                  ))}
                  {remainingUsersCount > 0 && (
                    <div className='profileChannel2'>
                      <span>+{remainingUsersCount}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })
      )}
      <br /> <br />
      <MyUpdateModal show={modalShowUp} onHide={() => setModalShowUp(false)} />
    </div>
  );
}

export default BranchesComp;
 